import React from "react";
import iconVps from "../../images/icons/icon-vps.svg";
import iconBaremetalStatus from "../../images/icons/icon-baremetal-status.svg";
import iconBaremetalConsole from "../../images/icons/icon-baremetal-console.svg";
import iconBaremetalReport from "../../images/icons/icon-baremetal-report.svg";
import imageHighlightBaremetalStatus from "../../images/image-highlight-vps-status.png";
import imageHighlightBaremetalConsole from "../../images/image-highlight-vps-api.png";
import imageHighlightBaremetalReport from "../../images/image-highlight-vps-report.png";
import Section from "../../components/ui/Section";
import PageHeroSection from "../../components/ui/PageSections/PageHeroSection";
import ServiceAddedValueSection from "../../components/ui/PageSections/ServiceAddedValueSection";
import ServiceHighlightsSection from "../../components/ui/PageSections/ServiceHighlightsSection";
import { navigate } from "gatsby";
import EmpowerServicesSection from "../../components/ui/PageSections/EmpowerServicesSection";
import PresenceBanner from "../../components/ui/PageSections/PresenceBanner";
import ContactUsBanner from "../../components/ui/PageSections/ContactUsBanner";
import PrimaryInputTable from "../../components/ui/InputTables/PrimaryInputTable";
import imageVps from "../../images/image-vps.png";

const VpsPageTemplate = ({ pageContext, translations }) => {
	//VPS highlights
	const serviceHighlightsList = [
		{
			title: translations["VPShighlightOneTitle"],
			text: translations["VPShighlightOneText"],
			icon: (
				<img
					src={iconBaremetalStatus}
					className="group-hover:fill-ipxonMagenta w-6 h-6 p-[2px] opacity-[.6]"
					alt="Cog with a person icon inside"
				/>
			),
			image: (
				<img
					className="rounded-[10px] w-full"
					src={imageHighlightBaremetalStatus}
					alt="Snapshot of a service"
				/>
			),
		},
		{
			title: translations["VPShighlightTwoTitle"],
			text: translations["VPShighlightTwoText"],
			icon: (
				<img
					src={iconBaremetalConsole}
					className="group-hover:fill-ipxonMagenta  w-6 h-6 p-[2px] opacity-[.6]"
					alt="Cog with arrow pointing right"
				/>
			),
			image: (
				<img className="rounded-[10px] w-full" src={imageHighlightBaremetalConsole} alt="Code in a terminal" />
			),
		},
		{
			title: translations["VPShighlightThreeTitle"],
			text: translations["VPShighlightThreeText"],
			icon: (
				<img
					src={iconBaremetalReport}
					className="group-hover:fill-ipxonMagenta  w-6 h-6 p-[2px] opacity-[.6]"
					alt="Pie chart"
				/>
			),
			image: (
				<img
					className="rounded-[10px] w-full"
					src={imageHighlightBaremetalReport}
					alt="Report of resources with graphics of a service"
				/>
			),
		},
	];

	return (
		<div className=" flex flex-col" id="VPSInputSection">
			<PageHeroSection
				heroTitle={translations["VPSMainTitle"] ? translations["VPSMainTitle"] : pageContext.h1Title}
				heroIcon={iconVps}
				heroIconAltText="White rombus rack icon"
				subtitle={translations["VPSSubtitle"] ? translations["VPSSubtitle"] : pageContext.h2Title}
				intro={translations["VPSIntro"]}
			/>

			<PrimaryInputTable
				serviceType="vps"
				defaultIataCode={pageContext.iataCode}
				translations={translations}
				pageContext={pageContext}
			/>

			<Section skewed="bottom">
				<div className="w-full flex flex-col xl:flex-row xl:gap-0">
					<div className="relative container w-full xl:w-2/5">
						<ServiceAddedValueSection
							secondaryTitle="VPSAddedValueSmallTitle"
							title="VPSAddedValueTitle"
							subTitle="VPSddedValueSubtitle"
							serviceTabs={[
								{
									title: "VPSAddedValueTitleOne",
									content: "VPSAddedValueTextOne",
								},
								{
									title: "VPSAddedValueTitleTwo",
									content: "VPSAddedValueTextTwo",
								},
								{
									title: "VPSAddedValueTitleThree",
									content: "VPSAddedValueTextThree",
								},
								{
									title: "VPSAddedValueTitleFour",
									content: "VPSAddedValueTextFour",
								},
							]}
							translations={translations}
						/>
					</div>
					<div className="bg-gray-100 p-4 md:p-8 rounded-lg max-w-[360px] h-fit m-auto mt-16 md:mt-0">
						<span className="border-2 cursor-default relative text-xs font-bold inline-flex items-start rounded-md py-0.5 px-2 z-0 border-black text-black">
							{translations["VPSGeyBoxLabel"]}
						</span>
						<div className="flex flex-col gap-4 my-8">
							<p className="text-sm text-ipxon-medium-dark-gray">{translations["VPSGreyBoxTextOne"]}</p>
							<p className="my-6 text-sm text-ipxon-medium-dark-gray">
								{translations["VPSGreyBoxTextTwo"]}
							</p>
							<img src={imageVps} className="max-w-[220px] m-auto" alt="VPS Server" />
						</div>
					</div>
				</div>
			</Section>
			<Section color="transparent">
				<ServiceHighlightsSection
					title={translations["VPShighlightsTitle"]}
					subtitle={translations["VPShighlightsSmallTitle"]}
					text={translations["VPShighlightsSubtitle"]}
					highlights={serviceHighlightsList}
					defaultImage={
						<img
							className="rounded ServiceHighlights border-opacity-50 border border-gray-500"
							src={imageHighlightBaremetalStatus}
							alt="Interface showing a service and its status as well as buttons to control the service"
						/>
					}
					theme="primary"
					buttonText={translations["BaremetalhighlightsButtonText"]}
					onClickHandler={() => {
						navigate("#VPSInputSection");
					}}
				/>

				<EmpowerServicesSection translations={translations} />
			</Section>
			<Section>
				<PresenceBanner translations={translations} />
			</Section>
			<Section color="transparent">
				<ContactUsBanner
					title={translations["BaremetalContactUsBannerTittle"]}
					subtitle={translations["BaremetalContactUsBannerSubTittle"]}
					contactText={translations["contact"]}
				/>
			</Section>
		</div>
	);
};

export default VpsPageTemplate;
